import React, { useEffect, useRef, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import Header from "../../components/header/header";
import HeaderRevamp from "../../components/headerRevamp";

import Footer from "../../components/footerRevamp";

import { useDispatch } from "react-redux";
import globalVariable from "../globalVariable";
import { fetchWithWait } from "../../helper/methods";
import { removeCookie } from "../../redux/actions/removeCookies";
import Popup from "reactjs-popup";
import "./sessionExpiryPopup.css";
import MSnackBar from "../../components/molecules/MSnackBar";
import { useHistory } from "react-router-dom";

const loginPagePathName =
  process.env.REACT_APP_MODE === "production" ? "/mutualfund/login" : "/login";

const PublicRoute = ({
  component: Component,
  restricted,
  hideNavBarMenus = false,hideHeaderFooter=false,
  ...rest
}) => {
  let dispatch = useDispatch();
  const history = useHistory();

  const [showPopup, setshowPopup] = useState(false);
  const [snackBar, setSnackBar] = useState({
    message: "Your session has been expired!! Kindly login again.",
    severity: "error",
  });
  const singleTimeRef = useRef(false);

  useEffect(() => {
    // Subscribe to the 'httpError' event
    console.log("rest.location.pathname", rest.location.pathname);
    // if (rest.location?.pathname != "/onboarding/personal") {
    const onHttpError = (status) => {
      if (status === "failed" && !singleTimeRef.current) {
        singleTimeRef.current = true;
        setshowPopup(true);
        localStorage.setItem("sessionExpired", true);
        localStorage.setItem("triggered401", true);
      }
    };

    let events = globalVariable.getPropertyByName("events");
    events.subscribe("httpError", onHttpError);

    // }
    console.log("mounting PrivateRoute");

    return () => {
      // Clean up the subscription when the component unmounts
      events.unsubscribe("httpError", onHttpError);
      console.log("unmounting PrivateRoute");
    };
  }, []);

  const popupClose = (e) => {
    fetchWithWait({ dispatch, action: removeCookie() })
      .then((res) => {
        setshowPopup(false);
        localStorage.removeItem("sessionExpired");
        localStorage.removeItem("triggered401");

        if (window.location.pathname !== loginPagePathName) {
          // window.location.href = loginPagePathName;
          history.push("/login");
        }
      })
      .catch((err) => {
        console.log("err in removeCookie: ", err);
        setshowPopup(false);
        localStorage.removeItem("sessionExpired");
        localStorage.removeItem("triggered401");
        if (window.location.pathname !== loginPagePathName) {
          // window.location.href = loginPagePathName;
          history.push("/login");
        }
      });
  };

  const isLoginPage = rest.path === "/login"; // Add NFO Countdown Timer to login page.
  const isQuickLoginPage = rest.path.includes("/partners-quicklogin");

  const showNFOCounter = isLoginPage;
  // const showNFOCounter = false;

  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <React.Fragment>
      {!isQuickLoginPage && !hideHeaderFooter ?
        <HeaderRevamp
          hideNavBarMenus={hideNavBarMenus}
          showNFOCounter={showNFOCounter}
          isLoginPage={isLoginPage}
        />
        :
        null
      }

      <Route
        {...rest}
        render={(props) =>
          restricted ? (
            <Redirect to="/portfolio" />
          ) : (
            <div style={{ minHeight: "500px" }}>
              <Component {...props} />
            </div>
          )
        }
      />
      {!isQuickLoginPage && !hideHeaderFooter ? <Footer /> : null}
      {showPopup ? (
        <>
          {/* <Popup open={showPopup} onClose={popupClose} className="sessionExpiredPP" modal>
              <div className="popup-contents">
                <h2>Session Expired</h2>
                <p>Your session has been expired!! Kindly login again.</p>
                <button onClick={popupClose}>Login</button>
              </div>
            </Popup> */}

          <MSnackBar
            open={showPopup}
            hideDuration={1000}
            handleClose={popupClose}
            severity={snackBar.severity}
            message={snackBar.message}
          />
        </>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

export default PublicRoute;
